import type { View } from '../nav/NavContext.js'

/** Small line icons (24x24, currentColor) for the sidebar and Home cards. */
const PATHS: Record<View, string> = {
  home: 'M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10',
  dashboard: 'M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z',
  enquiries: 'M4 5h16v11H9l-5 4zM8 9h8M8 12h5',
  bookings: 'M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h7',
  planning: 'M4 6h16M4 12h10M4 18h16M18 10l2 2-2 2',
  trips: 'M3 6h11v10H3zM14 9h4l3 3v4h-7zM7 19a1.8 1.8 0 100-.01M17 19a1.8 1.8 0 100-.01',
  'petty-cash': 'M3 7h18v12H3zM3 11h18M16 15h2',
  billing: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6',
  payables: 'M12 3v12M8 11l4 4 4-4M4 19h16',
  profitability: 'M4 19V5M4 19h16M8 15l4-4 3 3 5-6',
  reports: 'M5 4h14v16H5zM9 16v-4M12 16V8M15 16v-6',
  masters: 'M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19 12l2-1-2-4-2 .5-1.5-1L15 4h-4l-.5 2.5-1.5 1L7 7 5 11l2 1v1l-2 1 2 4 2-.5 1.5 1L11 20h4l.5-2.5 1.5-1 2 .5 2-4-2-1z',
  audit: 'M5 4h14v16H5zM9 9h6M9 13h6M9 17h3',
}

export function NavIcon({ name, size = 20 }: { name: View; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  )
}
